// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".price-reduction[data-v-162d25ea]{display:flex;justify-content:flex-end}.price-reduction .badge-price-reduction[data-v-162d25ea]{color:#fff;font-size:.8em;line-height:1.2em;padding:.14em .35em .2em;line-height:1.1em;text-align:center;min-width:1.5em;background:var(--color_ci);border-radius:5px;display:inline-block;margin-left:.5em}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
